import { ApiType } from "@gymflow/common";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { xeroQueryKeys } from "./xeroQueryKeys";

export const useMutationXeroUpdateAccountMapping = ({
  api,
  clubId,
}: {
  api: ApiType;
  clubId: number;
}) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (
      opts: Parameters<ApiType["xeroApi"]["updateAccountMapping"]>[0],
    ) => await api.xeroApi.updateAccountMapping(opts),
    onSuccess: async () =>
      await queryClient.invalidateQueries({
        queryKey: xeroQueryKeys.getIntegrationStatus(clubId),
      }),
  });
};
